export default __webpack_public_path__ + "static/media/Convention-center_normal.56fdc490.png";